import { Drawer, Box, Accordion } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
  },
});

export const HeaderBox = styled(Box)({
  background: "#1976d2",
  color: "white",
  padding: "16px 20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const StyledAccordion = styled(Accordion)(() => ({
  marginBottom: "12px",
  borderRadius: "12px !important",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  "&:before": { display: "none" },
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
  },
}));

export const StatBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "8px 12px",
  borderRadius: "8px",
  background: "rgba(255, 255, 255, 0.8)",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  marginBottom: "8px",
});
